// src/components/sections/PrivacyPolicy.tsx
import React from 'react';

const PrivacyPolicy: React.FC = () => {
  return (
    <div>
      <h1>Política de Privacidad y Seguridad</h1>

      <h2>1. Introducción</h2>
      <p>
        Nuestra política de privacidad tiene como objetivo proteger y respetar tu privacidad y tus datos personales. 
        Esta política describe cómo recopilamos, utilizamos y protegemos la información que proporcionas al utilizar nuestro sitio web y servicios.
      </p>

      <h2>2. Información que Recopilamos</h2>
      <p>
        Recopilamos los siguientes tipos de información:
      </p>
      <ul>
        <li><strong>Información Personal:</strong> Nombre, dirección de correo electrónico, etc., proporcionada por los usuarios al registrarse o interactuar con nuestros servicios.</li>
        <li><strong>Datos de Uso:</strong> Información sobre cómo los usuarios interactúan con nuestro sitio web y servicios (por ejemplo, las páginas que visitas y las acciones que realizas).</li>
      </ul>

      <h2>3. Uso de la Información</h2>
      <p>
        Utilizamos la información recopilada para los siguientes fines:
      </p>
      <ul>
        <li>Proporcionar acceso a nuestros servicios y contenido.</li>
        <li>Mejorar nuestro sitio web y servicios.</li>
        <li>Personalizar la experiencia del usuario.</li>
        <li>Comunicarnos con los usuarios sobre actualizaciones, novedades y promociones.</li>
      </ul>

      <h2>4. Compartir Información</h2>
      <p>
        No compartimos tu información personal con terceros, salvo en los siguientes casos:
      </p>
      <ul>
        <li>Cuando sea necesario para procesar servicios que has solicitado (por ejemplo, integración con Google Drive).</li>
        <li>Cuando estemos obligados por ley a compartir tu información.</li>
      </ul>

      <h2>5. Seguridad de los Datos</h2>
      <p>
        Tomamos medidas de seguridad razonables para proteger tus datos personales. Sin embargo, debes tener en cuenta que no podemos garantizar una seguridad absoluta contra todos los posibles riesgos en línea.
      </p>
      <p>
        Usamos encriptación SSL y otros métodos para proteger tus datos mientras se transmiten a través de nuestro sitio web.
      </p>

      <h2>6. Cookies</h2>
      <p>
        Utilizamos cookies para mejorar la experiencia del usuario. Las cookies son pequeños archivos de datos que se almacenan en tu dispositivo para permitirnos recordar tus preferencias y actividades en el sitio.
      </p>
      <p>
        Puedes configurar tu navegador para rechazar las cookies o para alertarte cuando se envíen, pero ten en cuenta que algunas partes del sitio pueden no funcionar correctamente sin ellas.
      </p>

      <h2>7. Tus Derechos</h2>
      <p>
        Tienes derecho a acceder, corregir o eliminar tu información personal en cualquier momento. Si deseas ejercer estos derechos, contáctanos a través de la información proporcionada en la sección de contacto de nuestro sitio web.
      </p>

      <h2>8. Cambios en la Política de Privacidad</h2>
      <p>
        Nos reservamos el derecho de actualizar esta política de privacidad en cualquier momento. Cualquier cambio será publicado en esta página y estará disponible para su consulta.
      </p>

      <h2>9. Contacto</h2>
      <p>
        Si tienes alguna pregunta o inquietud sobre nuestra política de privacidad o el tratamiento de tus datos personales, no dudes en contactarnos a través del correo jvasquezurrutia@gmail.com.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
